import React, { useState, useEffect, useRef } from "react";

export function useObserver(ref, delay = 0) {
  const [isVisible, setVisible] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setTimeout(
            () => {
              setVisible(entry.isIntersecting);
              observer.unobserve(ref.current);
            },
            delay
          );
        }
      });
    });
    observer.observe(ref.current);
  }, []);

  return isVisible;
}